import { render, staticRenderFns } from "./Mock.vue?vue&type=template&id=01a6db8c&scoped=true"
import script from "./Mock.vue?vue&type=script&lang=js"
export * from "./Mock.vue?vue&type=script&lang=js"
import style0 from "./Mock.vue?vue&type=style&index=0&id=01a6db8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a6db8c",
  null
  
)

export default component.exports